import React, { useState } from "react";
import { useTranslation } from "i18n";
import { dataTestIds } from "data-testids";
import DOMPurify from "dompurify";

import {
  addDots,
  getShortText,
  stripHtmlTags,
  BREAKING_LENGTH,
} from "./ReadMoreReadLess.helpers";

export interface IReadMoreReadLessProps {
  text: string;
}

export const ReadMoreReadLess: React.FC<IReadMoreReadLessProps> = ({
  text,
}) => {
  const { t } = useTranslation();

  const [expanded, setExpanded] = useState(false);
  const sanitizedText = DOMPurify.sanitize(text);

  const isLongText = stripHtmlTags(sanitizedText).length > BREAKING_LENGTH;
  const displayText =
    expanded || !isLongText
      ? sanitizedText
      : getShortText(sanitizedText, BREAKING_LENGTH);

  return isLongText ? (
    <div className="p-2.5 font-normal break-words text-[14px]">
      <span
        className="mr-1"
        dangerouslySetInnerHTML={{
          __html: expanded ? displayText : addDots(displayText),
        }}
      />
      {isLongText && (
        <button
          type="button"
          className="font-semibold text-color-brand-one"
          onClick={() => setExpanded((prev) => !prev)}
          data-testid={
            dataTestIds.componentLibrary[
              "Atoms.ReadMoreReadLess.show-more-show-less"
            ]
          }
        >
          {expanded
            ? t("common:button.label.readLess").toLowerCase()
            : t("common:button.label.readMore").toLowerCase()}
        </button>
      )}
    </div>
  ) : (
    <div
      className="read-more-read-less"
      dangerouslySetInnerHTML={{ __html: sanitizedText }}
    />
  );
};
